export default {"src":"/_next/static/media/Tick.ce1435ce.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};